/** Table-camera identity sampler interval. */
export const IDENTITY_SAMPLE_MS = 2000;

export function identityCheckpoint({ recording = false } = {}) {
  return recording ? "eval" : "exercise";
}

/**
 * Write a confirmed eval identity onto the clip setup so pose and matching
 * use the people in the footage.
 */
export function stampIdentityOnViewSetup(viewSetup, identity) {
  const left =
    identity?.left?.player_id || identity?.player_a_id || null;
  const right =
    identity?.right?.player_id || identity?.player_b_id || null;
  if (!left && !right) return { ...(viewSetup || {}) };
  const next = { ...(viewSetup || {}) };
  next.identity_player_a_id = left ? String(left) : null;
  next.identity_player_b_id = right ? String(right) : null;
  const assigned = [];
  if (left) {
    assigned.push({ position: "A", player_id: String(left), role: null });
  }
  if (right) {
    assigned.push({ position: "B", player_id: String(right), role: null });
  }
  if (assigned.length) next.assigned_players = assigned;
  return next;
}

export function identityUnconfirmed(status) {
  return Boolean(status && status.uncertain && !status.confirmed);
}
